// @vendors
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
const { withRouter } = require('react-router-dom');
// @helpers
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { getPersonTypeAndCode } = require('utilities/hash');
import { i18n } from 'core/i18n';
const { formatText, FormattedText } = i18n;
// @components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKButton } = require('commonsComponents/OKButton');
// @constants
const { CANCEL_CONTRIBUTION_MANAGMENT } = require('constants/operationTypes');
import { API_CHANNEL } from 'constants/index';
// @ actions
import BrokerPeriodicalFundsContributionsActions from 'actions/brokerPeriodicalFundsContributions';
// @helpers
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { recordPage, PROC_BROKER_INVESTMENT_CONTRIBUTIONS } = require('utilities/tagging');

const ContributionManagmentCancelContent = ({
  immBrokerPeriodicalFundsContributions,
  cancelPeriodicalContribution,
  history
}) => {

const isin = immBrokerPeriodicalFundsContributions.getIn([
 'periodicalContributionSelected',
 'isin',
 ]);

  useEffect(() => {
      const customData = {
        event_name: "view",
        pageName: "/cancelFundsPeriodicContribution",
        sectionFamily: "wealth",
        sectionCategory: "products",
        sectionName: "funds",
        serviceType: "productContracting",
        interactionType: "funnel",
        productName: isin
        }
      recordPage(customData);
  }, []);

    const fetchingCancelContribution = immBrokerPeriodicalFundsContributions.get('cancelPeriodicalContributionFetching')
  const marketName = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'marketName',
  ]);
  const periodicity = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'periodicityLabel',
  ]);
  const currencyCode = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'currencyCode',
  ]);
  const amount = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'amount',
  ]);
  const fullContract = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'fullContract',
  ]);
  const periodicalContributionCurrency = formatCurrency(currencyCode ? currencyCode : 'EUR');
  const periodicalContributionAmount = formatWithoutRound(amount, 2);
  const formatAmount = `${periodicalContributionAmount} ${periodicalContributionCurrency}`;
  const userData = getPersonTypeAndCode();
  const idUser = userData.f;
  const documentTypeUser = userData.type;
  const params = {
    ammount: `+${amount}`,
    currency: currencyCode,
    channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
    clientId: `${idUser}`,
    clientType: documentTypeUser,
    originAccount: fullContract,
  };

  const handleClickCancel = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'cancelButton', { name: marketName, isin: isin });
    history.push('/myprofile/broker/contributionManagment')
  };

  const handleClickBack = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'backButton', { name: marketName, isin: isin });
    history.push('/myprofile/broker/contributionManagment')
  };

  const handleClickHire = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'hireButton', { name: marketName, isin: isin });
    cancelPeriodicalContribution()
  }

  return (
    <div>
      <OKSectionBox className="cancel-contribution-managment-view">
        <h4 className="cancel-contribution-managment-view__title">
            <FormattedText value="brokerWealth-cancelContributionManagmentTitle"/>
        </h4>
        <p> <FormattedText value="brokerWealth-cancelContributionManagmentDescription"/></p>
        <div className="cancel-contribution-managment-view__details">
          <h4><FormattedText value="brokerWealth-cancelContributionManagmentSubTitle"/></h4>
          <div>
            <strong><FormattedText value="brokerWealth-cancelContributionManagmentFundName"/></strong>{marketName}
          </div>
          <div>
            <strong><FormattedText value="brokerWealth-cancelContributionManagmentAmount"/></strong>{formatAmount}
          </div>
          <div>
            <strong><FormattedText value="brokerWealth-cancelContributionManagmentPeriodicity"/></strong>{periodicity}
          </div>
        </div>
        <div>
          <SignaturePattern
            operationType={CANCEL_CONTRIBUTION_MANAGMENT}
            operationParams={params}
          />
        </div>
        <div className="container-cancel-contribution-managment-view__footer">
          <div className='container-cancel-contribution-managment-view__footer-backButton'>
            <OKButton
              modifier="ghost"
              onClick={handleClickCancel}
            >
                <FormattedText value="brokerWealth-cancelContributionManagmentCancelButton"/>
            </OKButton>
          </div>
          <div className='container-cancel-contribution-managment-view__footer-contractButton'>
            <OKButton
              modifier="ghost"
              leftIcon="icon-anterior"
              onClick={handleClickBack}
            >
                <FormattedText value="brokerWealth-cancelContributionManagmentPreviousButton"/>
            </OKButton>
            <OKButton modifier="primary" loading={fetchingCancelContribution} onClick={handleClickHire}>
                <FormattedText value="brokerWealth-cancelContributionManagmentHireButton"/>
            </OKButton>
          </div>
        </div>
      </OKSectionBox>
    </div>
  );
};

ContributionManagmentCancelContent.propTypes = {
  immBrokerPeriodicalFundsContributions: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    immBrokerPeriodicalFundsContributions: state.brokerPeriodicalFundsContributions,
  }),
  {
    cancelPeriodicalContribution:
      BrokerPeriodicalFundsContributionsActions.cancelPeriodicalContribution,
  }
)(withRouter(ContributionManagmentCancelContent));
